import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'video', 'listener' ]
  connect() {
    if (this.hasVideoTarget && this.hasListenerTarget) {
      this.videoTarget.addEventListener('timeupdate', (e) => {
        const angle = Math.floor((this.videoTarget.currentTime / this.videoTarget.duration) * 360) + 'deg';
        this.listenerTarget.style.background = `conic-gradient(#000 ${angle}, transparent ${angle})`;
      })
    }
  }
}

